import {Component} from "../../../gvf/js/component";
import {ObjectService} from "../../js/object-service";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";

export class DynamicFormButton extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        this.$root.click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.addClass("is-loading");
                const $button = $(ev.currentTarget);
                GvfService.endpoint(
                    "/cp/dynamic-form-instance-detail/init-instance",
                    {data:$button.data()}
                ).then(
                    (resp)=>{
                        const service = new ObjectService("DynamicFormInstance");
                        service.openDetailModal({
                            "editMode":true,
                            "objectId":resp.id,
                            "size":$(ev.currentTarget).data("modal-size"),
                            "saveCallback":(id)=>{
                                if(resp && !resp.noContext){
                                    const service = new ObjectService("DynamicFormInstance");
                                    service.openDetailModal({
                                        "editMode":true,
                                        "objectId":id,
                                        "size":$(ev.currentTarget).data("modal-size"),
                                        "saveCallback":()=>{
                                            this.$root.trigger("dynamicFormButton:instanceSaved",[id]);
                                        }
                                    });
                                }else{
                                    this.$root.trigger("dynamicFormButton:instanceSaved",[id]);
                                }
                            },
                            "readyCallback":()=>{
                                this.$root.removeClass("is-loading");
                            }
                        });
                    }
                ).catch(UtilsService.alertEndpointResponse);
            }
        );
    }
}

